module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/en-product2.2fe6c813.png";